import React from "react";
import { ROUTES } from "@Src/constants";
import { Trans } from "@lingui/react/macro";

function TermlyPreferences() {
  const handleConsentPreferences = (evt) => {
    try {
      window.displayPreferenceModal();
    } catch (error) {
      console.error("Error displaying consent preferences", error);
    }
    evt.preventDefault();
    return false;
  };
  return (
    <a href={ROUTES.HOME_PATH} onClick={handleConsentPreferences} id="termly-consent-preferences">
      <Trans>Consent Preferences</Trans>
    </a>
  );
}

export default TermlyPreferences;
